import React, { useEffect, useState } from 'react';
import { fetchEvents } from '../services/api';

export default function EventsEditor() {
    const [events, setEvents] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadEvents();
    }, []);

    const loadEvents = async () => {
        try {
            const res = await fetchEvents();
            setEvents(res.data);
            setError(null);
        } catch (err) {
            console.error('Error loading events:', err);
            setError('Failed to load events');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="p-4 animate-pulse">Loading events...</div>;
    if (error) return <div className="p-4 text-red-500">{error}</div>;
    if (!events) return <div className="p-4">No events data available</div>;

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Event Registry</h2>
            
            {events.total_entities !== undefined && (
                <div className="bg-yellow-50 rounded-lg p-4 mb-4">
                    <p className="text-2xl font-bold text-yellow-900">{events.total_entities}</p>
                    <p className="text-sm text-yellow-700">Total Entities</p>
                </div>
            )}
            
            {events.events && events.events.length > 0 ? (
                <div className="space-y-2">
                    {events.events.map((event, idx) => (
                        <div key={idx} className="bg-gray-50 rounded p-3">
                            <h4 className="font-medium text-sm">{event.entity}</h4>
                            <p className="text-xs text-gray-600">Table: {event.table}</p>
                            {event.event_types && event.event_types.length > 0 && (
                                <div className="mt-2">
                                    <span className="text-xs text-gray-500">Events: </span>
                                    {event.event_types.map((type, i) => (
                                        <span key={i} className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded mr-1">
                                            {type}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="bg-gray-100 p-4 rounded">
                    <p className="text-sm text-gray-600">No events registered yet</p>
                </div>
            )}
            
            {events.message && (
                <p className="text-xs text-gray-500 mt-4">{events.message}</p>
            )}
        </div>
    );
}